import { useContext } from 'react';
import { FlowForm, getKeyHandler } from 't-lib-ui/structure';
import { RouterContext, goTo } from 't-lib-ui/router';
import SearchIcon from './SearchIcon';
import QuestionMarkIcon from './QuestionMarkIcon';
import HeaderAuthButtons from './HeaderAuthButtons';
import { openQuickSearch } from './ThreeColumnLayout';
import './HeaderTools.css';

interface HeaderToolsProps {
  /** Replaces opening the search popup (Home toggles its own search bar instead). */
  onSearch?: () => void;
  /** Highlights the search button while its search is shown. */
  searchActive?: boolean;
  searchRef?: React.Ref<HTMLButtonElement>;
}

/** The right side of a page header: search button, help button and, in anonymous mode only, Log in /
 *  Sign up on the far right. A FlowForm, so the buttons join keyboard navigation (they sit outside the
 *  page's main FlowForm): arrow-up from the content reaches them, left/right cycles. */
const HeaderTools: React.FC<HeaderToolsProps> = ({ onSearch = openQuickSearch, searchActive, searchRef }) => {
  const routerCtx = useContext(RouterContext);
  const openHelp = () => goTo(routerCtx, '/a/help');
  return (
    <FlowForm className="headerToolsForm">
      <button
        ref={searchRef}
        type="button"
        className={`headerIconButton flowFocussable sidewayFocus${searchActive ? ' active' : ''}`}
        tabIndex={0}
        aria-label="Search feeds"
        aria-expanded={searchActive}
        title="Search feeds"
        onClick={onSearch}
        onKeyDown={getKeyHandler(onSearch)}
      >
        <SearchIcon size={22} strokeWidth={2} />
      </button>
      <button
        type="button"
        className="headerIconButton flowFocussable sidewayFocus"
        tabIndex={0}
        aria-label="Help"
        title="Help"
        onClick={openHelp}
        onKeyDown={getKeyHandler(openHelp)}
      >
        <QuestionMarkIcon size={22} />
      </button>
      <HeaderAuthButtons bare />
    </FlowForm>
  );
};

export default HeaderTools;
